import c from 'classnames';
import React from 'react';

import { TextColor, Typography } from '@repo/ui';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import OverviewWigglingMicrobesBackground from '../components/OverviewWigglingMicrobesBackground';

import { KitType } from '@repo/types';
import { AgeGroup, getAgeGroup } from '@repo/utils';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import styles from './Overview.module.css';
import slideStyles from './Slides.module.css';

export const Overview: React.FC = () => {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const ageGroup = getAgeGroup(currentKit?.age_at_sampling ?? 0);
  const isAdult = ageGroup === AgeGroup.ADULT;
  const name = currentTinyAccount?.first_name ?? '';
  const isVaginal = currentKit?.sampling_type === KitType.VAGINAL;

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.overview }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-2xl'
          color={TextColor.PURPLE}
          weight='medium'
        >
          Here’s what we looked at:
        </Typography>
        <ul>
          <li>
            {!isAdult ? `${name}'s` : 'Your'} overall{' '}
            {isVaginal ? 'vaginal' : 'gut'} microbiome health
          </li>
          <li>
            What’s inside {!isAdult ? `${name}'s` : 'your'}{' '}
            {isVaginal ? 'vaginal community' : 'gut'} and what it means for{' '}
            {!isAdult ? name : 'you'}
          </li>
          <li>Flagging metrics that need support or improvement</li>
          <li>Conditions associated with metrics</li>
          <li>Ways to improve {!isAdult ? `${name}'s` : 'your'} metrics</li>
        </ul>
      </div>
      <OverviewWigglingMicrobesBackground className={styles.backgroundImg} />
    </div>
  );
};
